import { apiGuestClient } from './apiGuestClient';

export const DAN_TOC_API_END_POINT = "dan-toc";

export const danTocApi = {
    selectAll: () => apiGuestClient.get(`${DAN_TOC_API_END_POINT}`),
};
